import './Navbar.css'

import React, { useEffect, useState } from 'react';
import MenuItems from './MenuItems';

const Navbar = ({ lang, user }) => {

    const API_URL = process.env.REACT_APP_SERVICE_API_URL;
    const [menuItems, setMenuItems] = useState([]);

    useEffect(() => {
        const fetchMenuItems = async () => {
            try {
                const response = await fetch(`${API_URL}/common/get_menu.php`);
                const data = await response.json();
                setMenuItems(data);
            } catch (error) {
                console.error('Error fetching menu:', error);
            }
        };

        fetchMenuItems();
    }, [lang, user]);

    return (<>
    <nav className="main-nav-menu">
        <ul className="menus">
            {menuItems.map((menu, index) => {
                        const depthLevel = 0;
                        return (
                        <MenuItems
                            items={menu}
                            key={index}
                            depthLevel={depthLevel}
                            />
                                    );
                    })}
        </ul>
    </nav>
    </>
            );
};

export default Navbar;